import * as React from "react";
const SvgSubtract = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "subtract_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M1.5 13.5h21a1.5 1.5 0 0 0 0-3h-21a1.5 1.5 0 0 0 0 3" }));
export { SvgSubtract as ReactComponent };
